// Read with `useFeatureFlag` (app-payload, repo/org/user gated) — not `isFeatureEnabled`.
export const RELATES_TO_FEATURE_FLAG = 'issues_relates_to_relationship'
